import { GMT_IST_DIFFERENCE } from '@app/_helpers';
import * as moment from 'moment';

export const AffiliateBookType = {
    STATUS: 'affiliate_status',
    FUNDS: 'affiliate_funds'
}

export const SortDirection = {
    ASC: 'ASC',
    DESC: 'DESC'
}

export const AffiliateStatus = {
    A: 'Awaiting',
    L: 'Logged In'
}

export const LeadStatusView = {
    GRID: 'grid',
    LIST: 'list'
}

export const AffiliateClientType = {
    'google': 'Google',
    'shareIndia': 'ShareIndia',
    'local': 'Local',
    'facebook': 'FaceBook',
    'bpClient': 'BP Client'
}

export interface AffiliateFundsRequest {
    from_date: number;
    to_date: number;
}

export const defaultAffiliateFundsRequest = {
    from_date: moment().startOf('day').add(GMT_IST_DIFFERENCE).unix(),
    to_date: moment().endOf('day').add(GMT_IST_DIFFERENCE).unix()
}

export const AffiliateFundsStrategyType = {
    CUSTOM: 'Custom',
    ORIGINAL: 'Original'
}
